<a [routerLink]="shopLink()" [queryParams]="shopLinkParams()">
  <ideal-image [src]="logoUrl()" fit="contain" />
</a>
